import { render, staticRenderFns } from "./ListEmergencyContact.vue?vue&type=template&id=0ab648fe&scoped=true"
import script from "./ListEmergencyContact.vue?vue&type=script&lang=js"
export * from "./ListEmergencyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab648fe",
  null
  
)

export default component.exports